/**
 * Generated runtime TestId mirror for frontend/src/pages/admin/ScriptExecuteLogPage.tsx.
 * DO NOT EDIT MANUALLY — re-run scripts/generate-testid-constants.py.
 *
 * Runtime mirror — same values as frontend/e2e/helpers/testids/. Help maps
 * under frontend/src/locales/ import this module to express computed-property
 * keys (e.g. `[XxxTestIds.fooBar]: '...'`).
 */

import type { TestIdPrefix } from "./types.ts";

export const ScriptExecuteLogPageTestIds = {
  clearFilters: "clear-filters",
  colActor: "col-actor",
  colDurationMs: "col-duration-ms",
  colErrorCode: "col-error-code",
  colMode: "col-mode",
  colOccurredAt: "col-occurred-at",
  colSqlText: "col-sql-text",
  colSuccess: "col-success",
  detailClose: "detail-close",
  detailErrorMessage: "detail-error-message",
  detailSqlText: "detail-sql-text",
  filterActor: "filter-actor",
  filterMode: "filter-mode",
  filterOccurredFrom: "filter-occurred-from",
  filterOccurredTo: "filter-occurred-to",
  filterSuccess: "filter-success",
  modePreview: "mode-preview",
  modeRuntime: "mode-runtime",
  scriptExecuteLogDetail: "script-execute-log-detail",
  scriptExecuteLogFilters: "script-execute-log-filters",
  scriptExecuteLogPage: "script-execute-log-page",
  successFalse: "success-false",
  successTrue: "success-true",
  scriptExecuteLogRow: (row_id: string) => `script-execute-log-row-${row_id}`,
  scriptExecuteLogRowPrefix: () => "script-execute-log-row-" as TestIdPrefix,
  sqlText: (row_id: string) => `sql-text-${row_id}`,
  sqlTextPrefix: () => "sql-text-" as TestIdPrefix
} as const;
